// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__IBMPlexSansBold_c53ac2', '__IBMPlexSansBold_Fallback_c53ac2'","fontWeight":700},"className":"__className_c53ac2","variable":"__variable_c53ac2"};